// extracted by mini-css-extract-plugin
export default {"drawer":"Drawer_drawer__Gs5wt","divider":"Drawer_divider__9DVB1"};